export default __webpack_public_path__ + "static/media/BigIcon.6e42ec11.JPG";